<template>
  <template v-if="hasChildren">
    <q-expansion-item
        :content-inset-level="level"
        :active="isActive"
        class="q-ml-none"
    >
      <template v-slot:header>
        <q-item-section
            @click.prevent="$emit('select', item)"
            :class="isActive ? 'text-primary' : ''"
        >
          {{ item.name }}
        </q-item-section>
        <q-item-section side v-if="isAdmin || isAnyAdmin">
          <div class="row">
            <q-btn flat round icon="add" size="sm" @click.stop="$emit('add', item)" v-if="isAdmin"/>
            <q-btn flat round icon="edit" size="sm" @click.stop="$emit('edit', item)" v-if="isAdmin"/>
            <q-btn flat round icon="delete" size="sm" @click.stop="$emit('delete', item)" v-if="isAdmin"/>
            <q-btn flat round icon="swap_horiz" size="sm" @click.stop="$emit('transfer', item)" v-if="isAnyAdmin"/>
          </div>
        </q-item-section>
      </template>

      <q-list dense>
        <ProjectTypeItem
            v-for="child in item.children"
            :key="child.id"
            :item="child"
            :level="level + 0.5"
            :selected-id="selectedId"
            :is-admin="isAdmin"
            :is-any-admin="isAnyAdmin"
            @select="$emit('select', $event)"
            @delete="$emit('delete', $event)"
            @edit="$emit('edit', $event)"
            @add="$emit('add', $event)"
            @transfer="$emit('transfer', $event)"
        />
      </q-list>
    </q-expansion-item>
  </template>

  <template v-else>
    <q-item
        clickable
        v-ripple
        @click="$emit('select', item)"
        :active="isActive"
        active-class="text-blue-8 bg-blue-3"
    >
      <q-item-section>{{ item.name }}</q-item-section>
      <q-item-section side v-if="isAdmin || isAnyAdmin">
        <div class="row">
          <q-btn flat round icon="add" size="sm" @click.stop="$emit('add', item)" v-if="isAdmin"/>
          <q-btn flat round icon="edit" size="sm" @click.stop="$emit('edit', item)" v-if="isAdmin"/>
          <q-btn flat round icon="delete" size="sm" @click.stop="$emit('delete', item)" v-if="isAdmin"/>
          <q-btn flat round icon="swap_horiz" size="sm" @click.stop="$emit('transfer', item)" v-if="isAnyAdmin"/>
        </div>
      </q-item-section>
    </q-item>
  </template>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {ProjectTypeSummary as PT} from "../models/project";

const props = defineProps<{
  item: PT,
  level: number,
  selectedId: number,
  isAdmin: boolean,
  isAnyAdmin: boolean,
}>();

const hasChildren = computed(() =>
    props.item.children && props.item.children.length > 0
);

const isActive = computed(() =>
    props.item.id === props.selectedId
);
</script>
